import { FC, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl/FormControl";
import InputLabel from "@mui/material/InputLabel/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput/OutlinedInput";
import React from "react";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import IconButton from "@mui/material/IconButton/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import ClearIcon from "@mui/icons-material/Clear";
//стили и интерфейсы пропсов
//копмпоненты
import SelectDrx from "./SelectDrx";
import SelectUser from "./SelectUser";
import SelectWorkPlace from "./SelectWorkPlace";
import {
  AxiosRequest,
  createCokies,
  getOptionsForUser,
  updateOptionsForUser,
  XMLrequest,
  checkGenLicGuid,
  getURLparam,
  getCookie,
  hasURLparam,
  removeParam,
} from "../Url";
import { useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import SignInDialog from "./SignInDialog";
import { createRoot, Root } from "react-dom/client";
import ModalSignIn from "./SignInWithCryptoPRO/ModalSignIn";
import { getStyleWindow, isEmptyObject, selectNewLicenseToInstall, selectOrg } from "../MainPage/Tools/Tools";
import {
  CheckModalBackGrounds,
  CreateBackgroundForModal,
  executeCertList,
  renderMessageBox,
  sendRequest,
  uuid,
} from "../TokenProcessing/TokenProcessing";
import ModalWindow from "../MainPage/Module/ModalWindow";
import ChangePassowrd from "../MainPage/NotWorkArea(Side&Head)/Header/ChangePassowrd";
import { getUrlSearh } from "../MainPage/Tools/urlParams";
import { smetaModals } from "../MainPage/Tools/modalManager";
import ChooseCert from "./SignInWithCryptoPRO/ChooseCert";
import DialogSetObjText from "../MainPage/Module/Dialogs/DialogSetObjText";
import { AxiosRequestConfig } from "axios";
import { useAtom, useSetAtom, useAtomValue } from "jotai";
import {
  helpContextAtom,
  appConfig,
  isAdminAtom,
  isAuthorized,
  isSuperUserAtom,
  configEnabledAtom,
  smetaStore,
  pingMinsAtom,
  isOrgEnterAtom,
} from "../../atoms";
import WorkSpaceInstall from "../MainPage/Tools/WorkSpaceInstall";
import smetaAxios from "../SmetaAxios";
import { Button as DlgButton } from "../MainPage/Tools/ProjectX";
import { hideSnow } from "../MainPage/WrapperMainFile";
// import Button from '@mui/material/Button';
// import {TestPlug} from "./core"

var Secret: any;

function isInstalledWorkSpace() {
  const workspaceEx = document.getElementById("WorkspaceEx");
  const isInstalled = workspaceEx?.getAttribute("is-installed");
  const isNewApi = workspaceEx?.getAttribute("is-new-api");
  const type = window.webkcrypt.type === "cades" || window.webkcrypt.type === "webkcrypt";
  if ((isInstalled && isNewApi) || type) return true;
  return false;
}

export function CheckWorkSpace(callBack?: any) {
  if (!isInstalledWorkSpace()) {
    const invokeCallback = () => {
      callBack?.();
    };
    smetaModals.open(
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
        <Grid item sx={{ textAlign: "center" }}>
          В вашем браузере не установлено расширения для работы <strong>КЭП</strong>. Для установки расширения нажите
          кнопку &quot;Ок&quot;.
        </Grid>
      </Grid>,
      {
        Title: "Уведомление",
        blockMaximize: true,
        blockSaveLocation: true,
        blockResize: true,
        style: { height: `${180}px`, width: `${380}px` },
        Buttons: {
          jsonData: {
            Кнопка$Выбрать: "Ок",
          },
          Params: { Buttons: DlgButton.Ok },
        },
        onClose: invokeCallback,
        onSelect: () => {
          smetaModals.open(<WorkSpaceInstall />, {
            Title: "Крипто-плагин",
            blockMaximize: true,
            blockSaveLocation: true,
            blockResize: true,
            style: { height: `${480}px`, width: `${580}px` },
            Buttons: {
              jsonData: {
                Кнопка$Выбрать: "Ок",
              },
              Params: { Buttons: DlgButton.Ok },
            },
            onSelect: invokeCallback,
            onClose: invokeCallback,
          });
        },
      },
    );
  }
  return isInstalledWorkSpace();
}

// export const CheckOtherEnters = (SignInFunc: any, subdata?: any) => {
//   const localStorageLogin: any = localStorage.getItem("login");
//   if (window.MultiSection === "1") return true;
//   if (window.hideEnter !== true) {
//     return true;
//   }
//   if (localStorageLogin !== sessionStorage.getItem("LicG")) {
//     if (localStorageLogin === "" || localStorageLogin === "leave" || localStorageLogin === null) {
//       return true;
//     }
//     CreateBackgroundForModal(
//       <ModalWindow
//         Title="Подтверждение"
//         style={{ height: `${180}px`, width: `${380}px` }}
//         Buttons={{
//           jsonData: {
//             Кнопка$Выбрать: "Выйти везде",
//             Кнопка$Отмена: "Остаться",
//           },
//           Params: { Buttons: "3" },
//         }}
//         onSelect={() => {
//           localStorage.setItem("login", "leave");
//           const licg: any = sessionStorage.getItem("LicG");
//           localStorage.setItem("login", licg);
//           SignInFunc(subdata);
//         }}
//         onClose={() => {
//           if (hasURLparam("Guid")) {
//             window.location.href = getURLparam("from").replaceAll("@", "/");
//           }
//           return;
//         }}
//       >
//         <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
//           <Grid item sx={{ textAlign: "center" }}>
//             Вы уже вошли в аккаунт, будет произведен автоматический выход на другой вкладке.
//           </Grid>
//         </Grid>
//       </ModalWindow>,
//     );
//     return false;
//   } else {
//     return true;
//   }
// };

export const setClientInfo = () => {
  const {
    smeta: { stimateVersion: version },
  } = smetaStore.get(appConfig);
  const ip = getOptionsForUser()?.IP;
  const iver = version.match(/(\d+\,?\d*)/g);
  const config: AxiosRequestConfig = {
    params: {
      host: window.location.host,
      port: window.location.port || null,
      ip: ip || "",
      comp: `${getBrowserType()};${getOS()}`,
      CVer: encodeURIComponent(version),
      IVer: iver?.join(""),
    },
  };

  const response = smetaAxios.get("SetClientInfo", config);
  if (response.PingMins) smetaStore.set(pingMinsAtom, Number(response.PingMins) * 60 * 1000);
  return response;
};

export function initContext() {
  let params = new Map();
  params.set("prefix", "documents");
  params.set("comand", "InitContext");
  // params.set('User', 'Project');
  params.set("LazyMemos", "1");
  return AxiosRequest(true, params);
}

function getOS() {
  let detectOS = "Unknown OS";

  if (navigator.userAgent.indexOf("Win") != -1) detectOS = "windows";

  if (navigator.userAgent.indexOf("Mac") != -1) detectOS = "MacOS";

  if (navigator.userAgent.indexOf("Linux") != -1) detectOS = "linux";
  return detectOS;
}

export function getBrowserType() {
  const test = (regexp: RegExp) => {
    return regexp.test(navigator.userAgent);
  };

  if (test(/opr\//i)) {
    return "Opera";
  } else if (test(/edg/i)) {
    return "Microsoft Edge";
  } else if (test(/chrome|chromium|crios/i)) {
    return "Chromium";
  } else if (test(/firefox|fxios/i)) {
    return "Mozilla Firefox";
  } else if (test(/safari/i)) {
    return "Apple Safari";
  } else if (test(/trident/i)) {
    return "Microsoft Internet Explorer";
  } else if (test(/ucbrowser/i)) {
    return "UC Browser";
  } else if (test(/samsungbrowser/i)) {
    return "Samsung Browser";
  } else {
    return "Unknown browser";
  }
}

export function clearUrl() {
  if (hasURLparam("Guid")) {
    // navigate("main");
    let url = removeParam("Guid", window.location.href);

    if (hasURLparam("authed_by")) {
      updateOptionsForUser({ authed_by: getURLparam("authed_by") });
      url = removeParam("authed_by", url);
    } else {
      if (hasURLparam("from")) updateOptionsForUser({ from: getURLparam("from") });
    }
    url = removeParam("stimWebSrv", url);
    if (hasURLparam("from")) url = removeParam("from", url);
    window.history.replaceState({ additionalInformation: "Переход" }, "Test", url);
  }
}

export const getUserInfo = (configName: string, userName: string) => {
  const config: AxiosRequestConfig = {
    params: {
      configName: configName,
      userName: userName,
    },
  };
  return smetaAxios.get("getUserInfo", config);
};

interface SmetaEnterPostData {
  configName: string;
  userName: string;
  workPlace: string;
  password: string;
  RCDATA?: string;
  orgTypeCls?: string;
  drx: string;
}
export const enterSmeta = (postData: SmetaEnterPostData, { ip = null }: { ip: string | null }) => {
  const config: AxiosRequestConfig = {
    params: {
      ip,
      SetLic: (postData.RCDATA && "1") || null,
    },
    loadMask: true,
  };
  return smetaAxios.post<SmetaEnterResponse>("enter", postData, config);
};

interface SmetaEnterResponse {
  ConfigEnabled?: "1" | "0";
  HelpContext?: string;
  IsAdmin?: "1" | "0";
  SessionID: string;
  SuperUser?: "1" | "0";
  Version: string;
  ConfigName?: string;
  UserName?: string;
  WorkPlace?: string;
}

export const updateStatesAfterEnter = (enterResp: SmetaEnterResponse, loginData: SmetaEnterPostData) => {
  const { drx, userName, workPlace } = loginData;
  const lastLogin = `${drx},${userName},${workPlace}`;
  createCokies("LastLogin", lastLogin);
  sessionStorage.setItem("LastLogin", lastLogin);
  const isAdmin = Boolean(enterResp.IsAdmin || enterResp.SuperUser),
    configEnabled = Boolean(enterResp.ConfigEnabled),
    isSuperUser = Boolean(enterResp.SuperUser),
    isOrgEnter = Boolean(loginData.orgTypeCls);
  if (enterResp.HelpContext) {
    updateOptionsForUser({ helpContext: enterResp.HelpContext });
    smetaStore.set(helpContextAtom, enterResp.HelpContext);
  }
  smetaStore.set(isOrgEnterAtom, isOrgEnter);
  smetaStore.set(isAdminAtom, isAdmin);
  smetaStore.set(configEnabledAtom, configEnabled);
  smetaStore.set(isSuperUserAtom, isSuperUser);
  updateOptionsForUser({
    isAdmin,
    configEnabled,
    isSuperUser,
    isOrgEnter,
  });
  clearUrl();
};

// eslint-disable-next-line
const SignIn = () => {
  document.title = "Вход в систему";

  const config = useAtomValue(appConfig);
  const navigate = useNavigate();
  const [drx, setDrx] = useState("");
  const [hasOrgs, setHasOrgs] = useState("0");
  const [user, setUser] = useState("");
  const [workplace, setWorkPlace] = useState("");
  const [password, setPassword] = useState("");
  const [load, setLoad] = useState(false);
  const [secret, setSecret] = useState<any>({});
  const [display, setDisplay] = useState<string>("none");
  const [showPassword, setShowPassword] = React.useState(false);
  const [orgTypeCls, setOrgTypeCls] = React.useState<any>(null);
  const [isSessionActive, setIsSessionActive] = useAtom(isAuthorized);

  useEffect(() => {
    if (isEmptyObject(secret) === false) {
      const appName = secret["AppName"];
      createCokies("drx", appName === undefined ? drx : appName);
      setIsSessionActive(true);
      navigate("main");
    }
  }, [secret]);

  useEffect(() => {
    setOrgTypeCls(null);
  }, [drx]);

  useEffect(() => {
    if (drx !== "") {
      getConfigInfo(drx, user);
    }
  }, [drx, user]);

  useEffect(() => {
    hideSnow(true);
    if (hasURLparam("Guid")) {
      sessionStorage.setItem("LicG", getURLparam("Guid"));
      createCokies("LicG", getURLparam("Guid"));
      handleSingIn();
    } else {
      checkSessionAndEnter().then((res) => {
        if (res === false) checkGenLicGuid(sessionStorage.getItem("LicG"), true);
      });
    }
    setDisplay(getStyleForEnter());
    return () => {
      setLoad(false);
    };
  }, []);

  const showLicenseMessage = (content: string) => {
    renderMessageBox({
      dlgType: 3,
      buttons: 12,
      message: `${content} Хотите выбрать новую лицензию для установки?`,
      selectF: async () => {
        const fileData = await selectNewLicenseToInstall();
        if (!isEmptyObject(fileData)) {
          const fileName = fileData.reqData.FileName;
          const rcdata = fileData.files[fileName].rcdata;
          handleSingIn({}, rcdata);
        }
      },
    });
  };

  async function checkSessionAndEnter() {
    const isActive = isSessionActive;
    if (isActive === true) {
      navigate(`main` + getUrlSearh());
    }
    return isActive;
  }

  function executeCertListAsXML() {
    executeCertList()
      .then((certList: string) => {
        smetaModals.open(<ChooseCert data={certList.split(/\r?\n/)} onSelect={signForEnterOnSelect} />, {
          Title: "Выбор сертификата",
          style: {
            height: `${530}px`,
            width: `${580}px`,
            overflow: "hidden",
          },
          hiddenButton: true,
          blockMaximize: true,
          blockResize: true,
        });
      })
      .catch(() => {
        if (CheckWorkSpace()) return;
      });
    return;
  }

  function signForEnterOnSelect(sn: string) {
    const json = smetaAxios.get("secret");
    Secret = json["Pkcs7Auth-Secret"].Secret;
    window.webkcrypt
      .make_pkcs7_signature(sn, Secret, true)
      .value.then((value: any) => {
        let fixedVal = value;
        fixedVal.replaceAll(" ", "");
        // fixedVal.replaceAll("\r\n","")
        fixedVal.replaceAll("\\r", "");
        fixedVal.replaceAll("\\n", "1234");
        console.log(fixedVal);

        handleMessage(removeLinebreaks(value));
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  function removeLinebreaks(str: string) {
    let newstr = "";
    for (let i = 0; i < str.length; i++) if (!(str[i] == "\n" || str[i] == "\r")) newstr += str[i];
    return newstr;
  }

  function getStyleForEnter() {
    if (hasURLparam("Guid") || (config.smeta.hideEnter !== undefined && config.smeta.hideEnter === true)) {
      return "none";
    } else {
      return "";
    }
  }

  async function getConfigInfo(drx: string, user: string) {
    const config: AxiosRequestConfig = {
      params: {
        configName: drx,
        userName: user || null,
      },
    };
    const resp = await smetaAxios.get("getConfigInfo", config);
    setHasOrgs(resp.HasOrgs === "1" ? "1" : "0");
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  function handleMessage(message: any) {
    if (!message) return;
    const loginData = {
      "Pkcs7Auth-Answer": {
        Answer: message,
      },
    };
    const json = smetaAxios.post("answer", loginData);
    const content = <ModalSignIn data={json} secret={Secret} keyFromSelect={message} setSecret={setSecret} />; //todo new modal
    const renderSignInEl = document.getElementById("renderSignIn")!;
    const renderSignInElRoot: Root = renderSignInEl.root || createRoot(renderSignInEl);
    renderSignInEl.root = renderSignInElRoot;
    renderSignInElRoot.render(content);
  }

  const navigatiToMain = async (IP: string) => {
    const licG = sessionStorage.getItem("LicG");
    localStorage.setItem("login", licG || "");
    const initData = await initContext();
    if (IP) {
      updateOptionsForUser({ IP: IP });
    }
    if (initData.RefWithCtrl) {
      updateOptionsForUser({ RefWithCtrl: initData.RefWithCtrl === "1" });
    }
    setIsSessionActive(true);
    navigate("main" + getUrlSearh());
  };

  const clientPasswordHandler = (event: any) => {
    setPassword(event.target.value);
  };

  function CheckAnswerFromServer(resp?: any) {
    setLoad(false);
    const enterErrors = {
      Password: () => {
        if (resp.NeedNewPW !== "1") return;
        smetaModals.open(
          <ChangePassowrd
            where={"signin"}
            onPasswordChange={(newPassword: string) => {
              handleSingIn({ password: newPassword });
            }}
          />,
          {
            style: { height: window.innerHeight * 0.35, width: window.innerWidth * 0.3 },
            hiddenButton: true,
            Title: resp.content,
          },
        );
      },
    };
    enterErrors[resp.Item]?.();
    if (resp.LicRes) showLicenseMessage(resp.content);
  }

  const handlekeyDownSignIn = (e: any) => {
    if (e.keyCode === 13 && CheckModalBackGrounds() === 0) {
      // if (!signOuted) SignOut();
      handleSingIn();
    }
  };

  const handleSingIn = async (loginObj = {}, rcdata?: string) => {
    const configName = orgTypeCls?.config || drx;
    const userInfo = await getUserInfo(configName, user);
    let ip: string;
    ip = userInfo.Server;
    if (hasURLparam("stimWebSrv") && getURLparam("stimWebSrv") !== undefined) {
      ip = getURLparam("stimWebSrv");
    }
    const loginData = {
      configName: orgTypeCls?.config || drx,
      userName: user,
      password: password,
      workPlace: workplace,
      RCDATA: rcdata,
      orgTypeCls: orgTypeCls?.code,
      drx: drx,
      ...loginObj,
    };
    if (!isEmptyObject(orgTypeCls)) {
      setLoad(true);
      axiosEnter(loginData, ip);
    } else if (hasOrgs === "1" && isEmptyObject(orgTypeCls)) {
      if (userInfo.Configs && userInfo.Configs.items && userInfo.Configs.items.length === 1) {
        axiosEnter(
          {
            ...loginData,
            orgTypeCls: userInfo.Configs.items[0].Code,
            configName: userInfo.Configs.items[0].Config || drx,
          },
          ip,
        );
      } else {
        selectOrg({ drx, user }).then((resp) => {
          if (!resp) return;
          setOrgTypeCls(resp);
          setLoad(true);
          axiosEnter({ ...loginData, orgTypeCls: resp.code, configName: resp.config }, ip);
        });
      }
    } else {
      axiosEnter(loginData, ip);
    }
  };

  async function axiosEnter(loginData: SmetaEnterPostData, ip: string | null = null) {
    const resp = await enterSmeta(loginData, { ip });
    setLoad(false);
    if (isEmptyObject(resp)) return;
    if (resp.error) return CheckAnswerFromServer(resp.error);
    updateStatesAfterEnter(resp, { ...loginData, drx });
    navigatiToMain(ip);
  }

  return (
    <Container maxWidth="xs" style={{ display: display, marginTop: "2%" }}>
      <CssBaseline />
      <div style={{ display: "flex", justifyContent: "center" }}>
        {config.smeta.signOptions?.headerSettings?.image && (
          <img
            src={"logoSmeta.png"}
            alt=""
            width={
              config.smeta.signOptions?.headerSettings?.imageWidth
                ? config.smeta.signOptions.headerSettings.imageWidth
                : ""
            }
          />
        )}
      </div>
      <Typography variant="h5" color={"#0098ad"} style={{ textAlign: "center" }}>
        {config.smeta?.signOptions?.headerSettings?.title !== undefined
          ? config.smeta?.signOptions?.headerSettings?.title
          : "Web-Смета"}
      </Typography>
      <Paper variant="elevation" elevation={10}>
        <Box
          sx={{
            p: 3,
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid container direction="column" justifyContent="space-around" alignItems="stretch" spacing={3}>
            <Grid item xs sx={{ display: config.smeta?.signOptions?.signButtons?.signCryptoButton ? "" : "none" }}>
              <Button
                style={{
                  backgroundColor: "#0098ad",
                  textTransform: "none",
                }}
                type="submit"
                fullWidth
                variant="contained"
                className="ButtonMargin"
                // onClick={handleSingIn}
                onClick={executeCertListAsXML}
              >
                Вход по ЭП
              </Button>
            </Grid>
            <Grid item xs sx={{ display: config.smeta?.signOptions?.signButtons?.helpKristaButton ? "" : "none" }}>
              <Button
                style={{
                  backgroundColor: "#0098ad",
                  textTransform: "none",
                }}
                type="submit"
                fullWidth
                variant="contained"
                className="ButtonMargin"
                // onClick={handleSingIn}
                onClick={() => {
                  window.open("https://help.krista.ru");
                }}
              >
                help.krista.ru
              </Button>
            </Grid>

            <Grid item xs sx={{ display: config.smeta?.signOptions?.signButtons?.lkButton ? "" : "none" }}>
              <Button
                style={{
                  backgroundColor: "#0098ad",
                  textTransform: "none",
                }}
                type="submit"
                fullWidth
                variant="contained"
                className="ButtonMargin"
                // onClick={handleSingIn}
                onClick={() => {
                  navigate("/lk" + getUrlSearh());
                }}
              >
                Вход в ЛК
              </Button>
            </Grid>

            <SelectDrx
              drxInfo={drx}
              setBackInfo={setDrx}
              password={undefined}
              userInfo={undefined}
              KeyDown={handlekeyDownSignIn}
            />

            <SelectUser
              HasOrgs={hasOrgs}
              userInfo={user}
              drxInfo={drx}
              setBackInfo={setUser}
              password={undefined}
              selectOrg={() => {
                selectOrg({ drx, user }).then((resp) => {
                  setOrgTypeCls(resp || orgTypeCls);
                });
              }}
              KeyDown={handleSingIn}
              selectedOrg={orgTypeCls}
            />

            <Grid item xs>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Пароль</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  onChange={clientPasswordHandler}
                  value={password}
                  onKeyDown={handlekeyDownSignIn}
                  endAdornment={
                    <InputAdornment position="end" sx={{ mr: 1 }}>
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            </Grid>

            <SelectWorkPlace
              drxInfo={drx}
              userInfo={user}
              workPlaceInfo={workplace}
              setBackInfo={setWorkPlace}
              password={undefined}
              KeyDown={handlekeyDownSignIn}
            />
            <Grid item>
              <Button
                style={{ backgroundColor: "#0098ad", textTransform: "none" }}
                type="submit"
                fullWidth
                variant="contained"
                className="ButtonMargin"
                onClick={() => {
                  handleSingIn();
                }}
              >
                Войти
              </Button>
            </Grid>
            <Grid id="renderSignIn"></Grid>
          </Grid>
        </Box>
      </Paper>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default SignIn;
